import { odinClient } from "@/config/client"
import type { ClientResponse } from "@educabot/fetcher/lib/types"

export interface CreateStudySessionResponse {
  description: {
    id: string
    agentMessage: string
  }
}

interface CreateStudySessionParams {
  id: string
  activityId: string
}

export function createStudySession(
  payload: CreateStudySessionParams,
): Promise<ClientResponse<CreateStudySessionResponse>> {
  return odinClient.post(`/v1/activities/${payload.activityId}/lessons/study-session`, {
    userActivityId: payload.id,
  })
}
